import { Stack, Typography } from "@mui/material";
import { Circle } from "@mui/icons-material";
import ProfileCard from "./ProfileCard";
import { formatDate, getTimeAgo } from "../../../helpers/formatDate";
import { useGetNotifications } from "../../../hooks/useGetNotifications/useGetNotifications";

const notifications = [
  {
    title: "Notification 1",
    description: getTimeAgo(new Date()),
  },
  {
    title: "Notification 2",
    description: getTimeAgo(new Date() - 1000 * 61),
  },
  {
    title: "Notification 3",
    description: getTimeAgo(new Date() - 1000 * 60 * 122),
  },
  {
    title: "Notification 4",
    description: getTimeAgo(new Date() - 1000 * 60 * 60 * 25),
  },
  {
    title: "Notification 5",
    description: getTimeAgo(new Date() - 1000 * 60 * 60 * 24 * 3),
  },
  {
    title: "Notification 6",
    description: getTimeAgo(new Date() - 1000 * 60 * 60 * 24 * 35),
  },
  {
    title: "Notification 7",
    description: getTimeAgo(new Date() - 1000 * 60 * 60 * 24 * 65),
  },
  {
    title: "Notification 8",
    description: getTimeAgo(new Date() - 1000 * 60 * 60 * 24 * 367),
  },
  {
    title: "Notification 9",
    description: getTimeAgo(new Date() - 1000 * 60 * 60 * 24 * 800),
  },
];

const ProfileNotifications = () => {
  const { notifications } = useGetNotifications();

  return <Stack direction="column" spacing={2} width="100%" alignItems="flex-start">
    <h1>Notifications</h1>
    <ProfileCard>
      {notifications?.map((notification) => (
        <Stack key={notification.title} direction={{ xs: "column", sm: "row" }} alignItems={{ xs: "flex-start", sm: "baseline" }} justifyContent="space-between" spacing={{ xs: 0, sm: 2 }} width="100%" sx={{ borderBottom: '1px solid #EDF0FC', paddingBottom: '10px'}}>
          <Stack direction="row" alignItems="baseline" spacing={2}>
            <Circle size={12} sx={{ color: "#657DF1" }} />
            <Typography variant="notificationTitle" dangerouslySetInnerHTML={{ __html: notification.message }} />
          </Stack>
          <Typography variant="notificationTime" sx={{ paddingLeft: { xs: '32px', sm: 0, textWrap: 'nowrap' } }}>{notification.createdAt ? getTimeAgo(new Date(notification.createdAt), 'short') : '-'}</Typography>
        </Stack>
      ))}
    </ProfileCard>
  </Stack>;
};

export default ProfileNotifications;    